import * as React from 'react';
import Slider from 'react-slick';

import { withTranslation } from 'react-i18next';


class LoginCarousel extends React.Component {
  constructor(props) {
    super(props);
    }

  render() {
    const { slides,t } = this.props;

    const renderSlides = () =>
      slides.map(slide => (
        <div className='carousel_login' key={slide.id}>
          <img src={slide.img} alt='Baylor Scott & White Health' />
          <div className='slide-text'>
            <div className='slide-heading-container'>
              <div className='slide-heading'>{slide.heading}</div>
                      <div className='slide-heading'>{t("My Way")}</div>
            </div>
            <div className='slide-body'>{slide.body}</div>
          </div>
        </div>
      ));

    const Arrow = props => {
      let className = props.type === 'next' ? 'next-arrow' : 'prev-arrow';
      className += ' arrow';
      const char =
        props.type === 'next' ? (
          <img src='images/right-arrow-blue.png' />
        ) : (
          <img src='images/left-arrow-blue.png' />
        );
      return (
        <span className={className} onClick={props.onClick}>
          {char}
        </span>
      );
    };

    return (
        <Slider ref={c => this.slider = c}
            nextArrow={<Arrow type='next' />}
            prevArrow={<Arrow type='prev' />}
            dots={true}
            autoplay={true}
            autoplaySpeed={4000}
            pauseOnHover={true}
            pauseOnFocus={true}
        >
        {renderSlides()}
      </Slider>
    );
  }
}

export default withTranslation()(LoginCarousel);
